import { render, staticRenderFns } from "./ModalPaymentDetail.vue?vue&type=template&id=636b1b62&scoped=true&"
import script from "./ModalPaymentDetail.vue?vue&type=script&lang=js&"
export * from "./ModalPaymentDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModalPaymentDetail.vue?vue&type=style&index=0&id=636b1b62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636b1b62",
  null
  
)

export default component.exports